import React from 'react'

import { FlowRoute } from 'utils/FlowProvider/types'

export const DIRECT_TO_MOBILE_HERO_COPY = new Map([
  [
    FlowRoute.DirectToMobileLander,
    {
      header: 'Download our app',
      text: 'Log in to our app to set up your account',
      subtext: `Simply download our Acorns app and enter your email and password. We’ll pick you up where 
      you left off!`,
    },
  ],
  [
    FlowRoute.Signup,
    {
      header: 'Create Account',
      text: (
        <>
          <strong>Acorns helps you save & invest</strong>
        </>
      ),
      veteranText: (
        <>
          <strong>Welcome To Acorns!</strong>
        </>
      ),
      subtext: (
        <>
          <p>
            Easily save & invest in the background of life. Invest your spare change, save for
            retirement, spend smarter, earn more, and grow your knowledge.
          </p>
        </>
      ),
      veteranSubtext: (
        <>
          <p>
            Sign up now to save & invest every day with Acorns. Plus, we'll invest $30 in you after
            you make your first investment this month. Proof of service will be required.
          </p>
        </>
      ),
      footnote: 'Protected by bank-level security',
      veteranCaption:
        'Gift and waiver provided to first 5,000 people that meet these criteria: ' +
        'New Acorns customers. Must be verified, link a bank account, and make an initial investment. ' +
        'Acorns reserves the right to check military eligibility.',
      footnoteLock: true,
    },
  ],
])
